<div class="mx-auto flex max-w-5xl flex-col space-y-4 p-5 animate-pulse">
  <!-- Header Skeleton -->
  <section class="flex flex-col gap-4 rounded-2xl border border-slate-800 bg-slate-900 p-5 shadow-lg md:flex-row md:items-center md:justify-between md:p-6">
    <div class="min-w-0 space-y-3 w-full">
      <div class="h-8 w-1/3 bg-slate-800 rounded"></div>
      <div class="h-8 w-1/4 bg-slate-800 rounded"></div>
      <div class="h-4 w-2/3 bg-slate-800 rounded"></div>
    </div>
    <div class="mt-3 w-full md:w-48 h-20 bg-slate-800 rounded-xl"></div>
  </section>

  <!-- Flow Status Skeleton -->
  <section class="rounded-2xl border border-slate-800 bg-slate-900 p-5 space-y-4">
    <div class="h-4 w-1/4 bg-slate-800 rounded"></div>
    <div class="flex justify-between items-start">
        <div class="space-y-2 w-1/2">
            <div class="h-6 w-3/4 bg-slate-800 rounded"></div>
            <div class="h-4 w-full bg-slate-800 rounded"></div>
        </div>
        <div class="h-16 w-20 bg-slate-800 rounded-2xl"></div>
    </div>
    <div class="h-2 w-full bg-slate-800 rounded-full"></div>
  </section>
</div>
